var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4374 4.27252C12.7641 3.2425 11.2359 3.24249 10.5626 4.27252L7.16316 9.47274L4.56478 8.00058C3.26302 7.26303 1.69785 8.41888 2.05047 9.85733L3.81575 17.0584C3.89523 17.3827 4.18964 17.6111 4.52808 17.6111H19.4719C19.8104 17.6111 20.1048 17.3827 20.1843 17.0584L21.9495 9.85733C22.3022 8.41887 20.737 7.26304 19.4352 8.00058L16.8368 9.47274L13.4374 4.27252ZM12.2053 5.05483C12.1092 4.90768 11.8908 4.90768 11.7947 5.05482L8.01794 10.8322C7.80654 11.1556 7.37505 11.2589 7.03666 11.0672L3.83432 9.25286C3.64835 9.1475 3.42475 9.31262 3.47513 9.51811L5.10494 16.1666H18.8951L20.5249 9.51811C20.5752 9.31262 20.3517 9.1475 20.1657 9.25286L16.9633 11.0672C16.6249 11.2589 16.1935 11.1556 15.9821 10.8322L12.2053 5.05483Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16008 18.9547C4.70149 18.9547 4.32725 19.3215 4.32725 19.777C4.32725 20.2324 4.70149 20.5992 5.16008 20.5992H18.8395C19.298 20.5992 19.6723 20.2324 19.6723 19.777C19.6723 19.3215 19.298 18.9547 18.8395 18.9547H5.16008Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePros);
export default __webpack_public_path__ + "static/media/active-pros.1c4cb9b2d3ff802ad0cb5a3d5b5f08ef.svg";
export { ForwardRef as ReactComponent };